<div class="position-relative">
  <span *ngIf="editable" class="position-absolute dropdown-indicator" (click)="toggleDropdown()"><i class="fas" [ngClass]="{'text-muted fa-chevron-down':!searching, 'fa-lg fa-circle-notch fa-spin text-info': searching}"></i></span>
  <input required #autoCompleteTrigger="matAutocompleteTrigger" tabindex="-1" (focusout)="testSelection($event)" #inputText matInput [placeholder]="placeholderText" [readonly]="!editable" (change)="setValue($event.value)" [ngClass]="{'form-control-plaintext':!editable}" [ngModel]="formatValue(selection)" class="form-control form-control-sm" (keyup)="search($event)" type="text" max="100" [matAutocomplete]="dropDownList" />
  <mat-autocomplete (opened)="search($event)" autoActiveFirstOption #dropDownList="matAutocomplete" (optionSelected)="setValue($event.option.value)">
    <mat-option *ngFor="let v of values" [value]="v">
      <span [innerHTML]="formatSearchResult(v)"></span>
    </mat-option>
    <mat-option *ngIf="values.length==0">
      <button *ngIf="canAdd()" class="float-right btn btn-primary btn-sm mt-4" (click)="onAdd()">
        <i class="fas fa-fw fa-lg fa-plus"></i>
        {{addItemText}}
      </button>
      <p class="text-muted small text-center mt-3">
        <em>
          {{noItemsText}}
        </em>
      </p>
    </mat-option>
  </mat-autocomplete>
</div>
